// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 100) return "js/100.js";
	if (chunkId === 472) return "js/472.js";
	// return url for filenames based on template
	return "" + "charts" + ".js";
};